export default __webpack_public_path__ + "static/media/chat-bg-pc.129ae144.png";